import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

// Auth Views
const LoginView = () => import('@/views/LoginView.vue')
const SignupView = () => import('@/views/SignupView.vue')
const PasswordRecoveryView = () => import('@/views/PasswordRecoveryView.vue')

// Settings Views
const SettingsView = () => import('@/views/SettingsView.vue')

// Appointments Views
const AppointmentsView = () => import('@/views/AppointmentsView.vue')
const SelectionView = () => import('@/views/SelectionView.vue')
const CalendarView = () => import('@/views/CalendarView.vue')
const AppointmentCancelView = () => import('@/views/AppointmentCancelView.vue')
const AutoLoginView = () => import('@/views/AutoLoginView.vue')
const AppointmentConfirmView = () => import('@/views/AppointmentConfirmView.vue')

// Files Views
const FilesView = () => import('@/views/FilesView.vue')

// Reports Views
const ReportsView = () => import('@/views/ReportsView.vue')

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'HomeView',
      redirect: '/seleccion'
    },
    {
      path: '/login',
      name: 'LoginView',
      component: LoginView,
      meta: { requiresAuth: false }
    },
    {
      path: '/registro',
      name: 'SignupView',
      component: SignupView
    },
    {
      path: '/recuperar-password',
      name: 'PasswordRecoveryView',
      component: PasswordRecoveryView
    },
    {
      path: '/configuracion',
      name: 'SettingsView',
      component: SettingsView,
      meta: { requiresAuth: true }
    },
    {
      path: '/seleccion',
      name: 'SelectionView',
      component: SelectionView
    },
    {
      path: '/calendario',
      name: 'CalendarView',
      component: CalendarView
    },
    {
      path: '/turnos',
      name: 'AppointmentsView',
      component: AppointmentsView,
      meta: { requiresAuth: true }
    },
    {
      path: '/documentos',
      name: 'FilesView',
      component: FilesView,
      meta: { requiresAuth: true }
    },
    {
      path: '/informes',
      name: 'ReportsView',
      component: ReportsView,
      meta: { requiresAuth: true }
    },
    {
      path: '/cancelar-turnos',
      name: 'AppointmentCancelView',
      component: AppointmentCancelView
    },
    {
      path: '/auto-login',
      name: 'AutoLoginView',
      component: AutoLoginView
    },
    {
      path: '/confirmar-turno',
      name: 'AppointmentConfirmView',
      component: AppointmentConfirmView
    }
  ]
})

// Route Guards
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.state.isUserLoggedIn
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next({ path: '/login', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  } else {
    if (isLoggedIn && to.path === '/login') {
      next({ path: '/turnos' })
    } else {
      next() // make sure to always call next()!
    }
  }
})

export default router
